export default {
  server_development: 'http://localhost:3001',
  server_test: 'https://test.restion.ru/backend',
  server: 'https://app.restion.ru/backend',
  auth: {
    entity: 'Base:UserCurrent',
    fields: ['id'],
  }
};
